import { Subscriber } from './subscriber.model';

export enum ProductStartIndex {
  Voice = 1,
  MBB = 1000,
  Hardware = 5000,
  Mobilephone = 6000,
  CustomerServiceProduct = 7000,
}

export enum HardwareCategory {
  Accessory = 'Accessory',
  MBBAccessory = 'MBBAccessory',
}

export class Product {
  id: string;

  subscriber: Subscriber;
  existingSubscriber: Subscriber;
  isExistingSubscription: boolean;
  isLoadingExistingSubscriber: boolean;

  constructor() {
    this.subscriber = new Subscriber();
  }
}
